const SvgCrossWhite = (props) => {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13.8042 1.24321L12.8371 0.287611C12.5754 0.0259289 12.1431 0.0259289 11.87 0.287611L7.04597 5.11155L2.13101 0.196591C1.86921 -0.0652049 1.43687 -0.0652049 1.16392 0.196591L0.196835 1.16368C-0.0649607 1.42536 -0.0649607 1.85771 0.196835 2.13076L5.10053 7.03446L0.287855 11.8699C0.026173 12.1316 0.026173 12.5639 0.287855 12.837L1.25494 13.8041C1.51662 14.0658 1.94897 14.0658 2.22203 13.8041L7.04597 8.98002L11.87 13.8041C12.1317 14.0658 12.5641 14.0658 12.8371 13.8041L13.8042 12.837C14.0659 12.5753 14.0659 12.143 13.8042 11.8699L8.96876 7.04584L13.7928 2.2219C14.0659 1.94861 14.0659 1.51627 13.8042 1.24321Z"
				fill="white"
			/>
		</svg>
	);
};

export default SvgCrossWhite;
